import React from "react";
import TextTheme from "../../../../components/General/Text/TextTheme";

class Payment extends React.Component {
  render() {
    return (
    <div className="dummy-page">
        <TextTheme 
        message="Payments Coming Soon"
        className="text_large text_dark_blue text-center text_semi_bold"
        />
    </div>
    );
  }
}


export default Payment;
